module.exports = __webpack_public_path__ + "img/mendoza.a37db7b8.jpg";